(function(){
  var CHEV='<svg class="vpd__dd-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var CHECK='<svg class="vpd__dd-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  function init(root){
    if(root.__vpd) return; root.__vpd=true;
    var data=JSON.parse(root.querySelector('[data-vpd-product]').textContent);
    var colorMap={};
    String(data.colors||'').split('\\n').forEach(function(l){ var p=l.split(':'); if(p[0]&&p[1]) colorMap[p[0].trim()]=p[1].trim(); });
    var optColor=data.options.find(function(o){return /color|colour|kleur|farbe|couleur/i.test(o.name);})||data.options[0];
    var iColor=data.options.indexOf(optColor);
    var tiers=[].slice.call(root.querySelectorAll('.vpd__tier input'));
    var itemsEl=root.querySelector('[data-vpd-items]');
    var totalEl=root.querySelector('[data-vpd-total]');
    var slides=root.querySelector('[data-vpd-main]');
    var frame=root.querySelector('.vpd__frame');
    var thumbs=[].slice.call(root.querySelectorAll('[data-vpd-thumb]'));
    var dots=[].slice.call(root.querySelectorAll('.vpd__dots span'));
    var atc=root.querySelector('[data-vpd-atc]');
    var bar=root.querySelector('[data-vpd-bar]');
    var barSub=bar&&bar.querySelector('[data-vpd-bar-sub]'), barPrice=bar&&bar.querySelector('[data-vpd-bar-price]'), barBtn=bar&&bar.querySelector('[data-vpd-bar-atc]'), barImg=bar&&bar.querySelector('.vpd__bar-img');
    var barSubFixed=barSub&&barSub.textContent.trim()!=='';
    var state=[], active=0, jumping=false;
    var cur=data.currency||'EUR', fmt;
    try{ fmt=new Intl.NumberFormat(data.locale||'en',{style:'currency',currency:cur}); }catch(_){ fmt=null; }
    function money(c){ return fmt?fmt.format(c/100):(c/100).toFixed(2)+' '+cur; }
    function esc(t){ return String(t).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); }
    function variantFor(c){ return data.variants.find(function(v){return v.options[iColor]===c;}); }
    function hex(c){ if(colorMap[c]) return colorMap[c]; var v=variantFor(c); var a=v&&v.featured_image&&v.featured_image.alt; return (a&&a.charAt(0)==='#')?a:'#d8ccd6'; }
    function img(c,w){ var v=variantFor(c); if(!v||!v.featured_image) return ''; var s=v.featured_image.src; return s+(s.indexOf('?')>-1?'&':'?')+'width='+(w||120); }
    function checked(){ return tiers.find(function(t){return t.checked;})||tiers[0]; }
    function qty(){ return tiers.length?Number(checked().value):1; }
    var count=slides?slides.children.length:0;
    if(frame&&count>1){
      frame.insertAdjacentHTML('beforeend','<button type="button" class="vpd__arrow vpd__arrow--prev" aria-label="Previous image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button><button type="button" class="vpd__arrow vpd__arrow--next" aria-label="Next image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button><span class="vpd__count" aria-hidden="true"></span>');
      frame.querySelector('.vpd__arrow--prev').addEventListener('click',function(){ goTo((active-1+count)%count); });
      frame.querySelector('.vpd__arrow--next').addEventListener('click',function(){ goTo((active+1)%count); });
    }
    var countEl=frame&&frame.querySelector('.vpd__count');
    function setActive(i){
      active=i;
      thumbs.forEach(function(t,k){ var on=k===i; t.classList.toggle('is-active',on); if(on){ var p=t.parentNode; p.scrollLeft=t.offsetLeft-p.clientWidth/2+t.clientWidth/2; } });
      dots.forEach(function(t,k){t.classList.toggle('is-active',k===i);});
      if(countEl) countEl.textContent=(i+1)+' / '+count;
    }
    function goTo(i){
      if(!slides) return;
      var x=slides.clientWidth*i;
      setActive(i); jumping=true;
      try{ slides.scrollTo({left:x,behavior:'smooth'}); }catch(_){ slides.scrollLeft=x; }
      setTimeout(function(){ if(Math.abs(slides.scrollLeft-x)>4){ slides.style.scrollSnapType='none'; slides.scrollLeft=x; slides.style.scrollSnapType=''; } jumping=false; },450);
    }
    function showColor(c){ var v=data.variants.find(function(x){return x.options[iColor]===c&&x.featured_media;}); if(!v||!slides) return; var idx=[].slice.call(slides.children).findIndex(function(s){return s.dataset.mediaId==v.featured_media.id;}); if(idx>-1) goTo(idx); }
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ goTo(Number(t.dataset.vpdThumb)); }); });
    if(slides){ var st; slides.addEventListener('scroll',function(){ if(jumping) return; clearTimeout(st); st=setTimeout(function(){ setActive(Math.round(slides.scrollLeft/slides.clientWidth)); },80); },{passive:true}); }
    function face(c){ var im=img(c,96); return im?'<img class="vpd__dd-img" src="'+im+'" alt="" width="36" height="36" loading="lazy">':'<i class="vpd__dd-dot" style="--c:'+hex(c)+'"></i>'; }
    function btnInner(c){ return face(c)+'<span class="vpd__dd-name">'+esc(c)+'</span><i class="vpd__dd-dot vpd__dd-dot--sm" style="--c:'+hex(c)+'"></i>'+CHEV; }
    function rowHtml(it,i,n){
      var name=n>1?(data.itemLabel+' '+(i+1)):data.colorLabel;
      var opts=optColor.values.map(function(val){
        var v=variantFor(val), dis=v&&!v.available, on=val===it.c;
        return '<li><button type="button" class="vpd__sw'+(on?' is-on':'')+'" role="option" aria-selected="'+on+'" data-c="'+esc(val)+'"'+(dis?' disabled':'')+'><i class="vpd__dd-dot" style="--c:'+hex(val)+'"></i><span>'+esc(val)+(dis?' – sold out':'')+'</span>'+CHECK+'</button></li>';
      }).join('');
      return '<div class="vpd__row" data-i="'+i+'"><span class="vpd__row-l">'+esc(name)+'</span><div class="vpd__dd"><button type="button" class="vpd__dd-btn" aria-haspopup="listbox" aria-expanded="false">'+btnInner(it.c)+'</button><ul class="vpd__dd-list" role="listbox" hidden>'+opts+'</ul></div></div>';
    }
    function closeAll(except){ root.querySelectorAll('.vpd__dd.is-open').forEach(function(d){ if(d===except) return; d.classList.remove('is-open'); d.querySelector('.vpd__dd-list').hidden=true; d.querySelector('.vpd__dd-btn').setAttribute('aria-expanded','false'); }); }
    function slot(){ if(tiers.length){ var b=checked().closest('.vpd__tierbox'); return b?b.querySelector('[data-vpd-slot]'):itemsEl; } return itemsEl; }
    function tierImg(){
      var src=state[0]&&img(state[0].c,120);
      var b=tiers.length&&checked().closest('.vpd__tierbox'); var ti=b&&b.querySelector('.vpd__tier-img');
      if(ti&&src){ ti.removeAttribute('srcset'); ti.src=src; }
      if(barImg&&src){ barImg.removeAttribute('srcset'); barImg.src=src; }
    }
    function render(){
      var n=qty();
      var avail=optColor.values.filter(function(v){var x=variantFor(v);return !x||x.available;});
      var start=data.currentColor&&optColor.values.indexOf(data.currentColor)>-1?data.currentColor:(avail[0]||optColor.values[0]);
      while(state.length<n){ var k=state.length; state.push({c: k===0?start:(avail[k%avail.length]||start)}); }
      state=state.slice(0,n);
      root.querySelectorAll('[data-vpd-slot]').forEach(function(s){s.innerHTML='';});
      if(itemsEl) itemsEl.innerHTML='';
      var t=slot(); if(t) t.innerHTML=state.map(function(it,i){return rowHtml(it,i,n);}).join('');
      tierImg(); total();
    }
    function total(){
      var c=checked(); var n=qty(), pct=c?Number(c.dataset.pct||0):0, free=c?Number(c.dataset.free||0):0;
      var t=Math.round(data.variants[0].price*Math.max(n-free,0)*(100-pct)/100);
      if(totalEl) totalEl.textContent=money(t);
      if(barPrice) barPrice.textContent=money(t);
      if(barSub&&!barSubFixed){ var tt=c&&c.closest('.vpd__tier'); var tl=tt&&tt.querySelector('.vpd__tier-title'); barSub.textContent=tl?tl.textContent:''; }
      tiers.forEach(function(x){ var b=x.closest('.vpd__tierbox'); if(b) b.classList.toggle('is-active',x.checked); });
    }
    root.addEventListener('click',function(e){
      var tb=e.target.closest('.vpd__dd-btn');
      if(tb){
        e.preventDefault(); e.stopPropagation();
        var dd=tb.parentNode, open=!dd.classList.contains('is-open');
        closeAll(dd);
        dd.classList.toggle('is-open',open); dd.querySelector('.vpd__dd-list').hidden=!open; tb.setAttribute('aria-expanded',open);
        if(open){ var l=dd.querySelector('.vpd__dd-list'), sel=dd.querySelector('.vpd__sw.is-on'); if(sel) l.scrollTop=sel.offsetTop-l.clientHeight/2; }
        return;
      }
      var b=e.target.closest('.vpd__sw'); if(!b||b.disabled) return;
      e.preventDefault(); e.stopPropagation();
      var row=b.closest('.vpd__row'); var i=Number(row.dataset.i); var c=b.dataset.c;
      state[i].c=c;
      row.querySelectorAll('.vpd__sw').forEach(function(x){ var on=x===b; x.classList.toggle('is-on',on); x.setAttribute('aria-selected',on); });
      row.querySelector('.vpd__dd-btn').innerHTML=btnInner(c);
      closeAll();
      if(i===0) tierImg();
      showColor(c);
    });
    document.addEventListener('click',function(e){ if(!e.target.closest('.vpd__dd')) closeAll(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(); });
    tiers.forEach(function(t){ t.addEventListener('change',render); });
    if(atc) atc.addEventListener('click',async function(e){
      var err=root.querySelector('[data-vpd-error]');
      var counts={};
      state.forEach(function(it){ var v=variantFor(it.c); if(v) counts[v.id]=(counts[v.id]||0)+1; });
      var items=Object.keys(counts).map(function(id){return {id:Number(id),quantity:counts[id]};});
      if(!items.length){ items=[{id:Number(data.currentVariant),quantity:qty()}]; }
      if(err) err.hidden=true;
      var btn=atc; btn.disabled=true; if(barBtn) barBtn.disabled=true;
      var lab=root.querySelector('[data-vpd-atc-label]'); var labTxt=lab?lab.textContent:''; if(lab) lab.textContent=data.addingText;
      var barTxt=barBtn?barBtn.textContent:''; if(barBtn) barBtn.textContent=data.addingText;
      var hdr={'Content-Type':'application/json',Accept:'application/json'};
      var added=false;
      function done(){ btn.disabled=false; if(lab) lab.textContent=labTxt; if(barBtn){ barBtn.disabled=false; barBtn.textContent=barTxt; } }
      try{
        if(data.afterAdd==='checkout') await fetch('/cart/clear.js',{method:'POST',headers:hdr}).catch(function(){});
        var r=await fetch('/cart/add.js',{method:'POST',headers:hdr,body:JSON.stringify({items:items,sections:'cart-drawer-section'})});
        var resp=await r.json();
        if(!r.ok||resp.status) throw new Error('add');
        added=true;
        if(data.afterAdd==='checkout'){ location.href='/checkout'; return; }
        if(data.afterAdd==='cart'){ location.href=data.cartUrl; return; }
        var drawer=document.getElementById('cart-drawer');
        if(!drawer||typeof drawer.open!=='function'){ location.href=data.cartUrl; return; }
        try{
          var ev=await import('@shopify/events'); var CLU=ev.CartLinesUpdateEvent;
          var cart=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(x){return x.json();});
          var d=CLU.createPromise();
          document.dispatchEvent(new CLU({action:'add',context:'product',lines:items.map(function(i){return {merchandiseId:String(i.id),quantity:i.quantity};}),promise:d.promise}));
          d.resolve({cart:CLU.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:'veronni-product',itemCount:items.reduce(function(n,i){return n+i.quantity;},0),productId:String(data.productId||''),sections:resp.sections,didError:false}});
        }catch(_){}
        if(!drawer.isOpen) drawer.open();
        done();
      }catch(_){
        if(added){ location.href=data.cartUrl; return; }
        done(); if(err) err.hidden=false;
      }
    });
    if(barBtn&&atc) barBtn.addEventListener('click',function(){ if(!atc.disabled) atc.click(); });
    if(bar){
      var target=atc||root.querySelector('.vpd__info'), ticking=false;
      var check=function(){ ticking=false; var rb=target.getBoundingClientRect(); var on=rb.bottom<0; bar.classList.toggle('is-on',on); bar.setAttribute('aria-hidden',on?'false':'true'); if(barBtn) barBtn.tabIndex=on?0:-1; };
      addEventListener('scroll',function(){ if(!ticking){ ticking=true; requestAnimationFrame(check); } },{passive:true});
      check();
    }
    setActive(0);
    render();
  }
  function boot(){ document.querySelectorAll('[data-vpd]').forEach(function(r){ try{ init(r); }catch(e){ console.error('veronni-product',e); } }); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();